import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Toast from 'react-bootstrap/Toast';


function DismissibleExample( {toastText, showToast ,setShowToast}) {


  return (
    <div style={{position: 'absolute', top: 30, right: 50, zIndex: 1000}}>
        <Toast show={showToast} onClose={()=> setShowToast(false)} bg={'danger'}>
            <Toast.Header>
            <img
                src="holder.js/20x20?text=%20"
                className="rounded me-2"
                alt=""
            />
            <strong className="me-auto">Upozornění</strong>
    
            </Toast.Header>
        <Toast.Body>{toastText}</Toast.Body>
        </Toast>
    </div>
  );
}

export default DismissibleExample;